/* global require */
/* global jQuery */
'use strict'; //eslint-disable-line
const util = require('util');

angular
  .module('washCancelRequest')
  .component('washCancelRequest', {
    template: require('./wash-cancel-request.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function WashCountController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.showOrderView = $rootScope.gShowOrderView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'orders';
        $rootScope.menu = 'washCancelRequest';
        $scope.selectedCityId = '-1';
        let reasons = [];
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        const errorHandler = (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        };
        $resource(`${APIURL}/admin/orders/cancel/reasons`).get().$promise
          .then((data) => {
            reasons = data.methods;
          })
          .catch((err) => {
            errorHandler(err);
          });
        const getReasonFromType = (type) => {
          const reason = reasons.filter(r => type === r.TYPE);
          if (!reason || reason.length < 1) { return { TYPE: '01', MESSAGE: '', DESC: '' }; }
          return reason[0];
        };
        const changeReason = () => {
          this.returnCancelData.DESCRIPTION = util.format(getReasonFromType(this.viewRequest.TYPE).DESC, this.viewRequest.CAR_BRAND);
        };
        this.paging = (page) => {
          this.curPage = page;
          $resource(`${APIURL}/admin/orders/cancel/request`).get({ page: page - 1, status: this.selectedStatus }).$promise
            .then((data) => {
              this.requests = data.reasons;
              this.totalCount = data.totalCount;
            })
            .catch((err) => {
              errorHandler(err);
            });
        };
        this.viewCancelRequest = (request) => {
          if (!AuthService.isAuthenticated()) {
            $location.path('/login');
            return;
          }
          if (!request) {
            return;
          }
          this.selectedMedias = [];
          this.confirmMedias = [];
          $resource(`${APIURL}/admin/orders/cancel/request/${request.ID}`).get({}).$promise
            .then((data) => {
              this.viewRequest = data.reason;
              this.viewRequest.CAR_BRAND = `${data.reason.ORDER_CAR_MAKER_NAME} ${data.reason.ORDER_CAR_NAME}`;
              this.returnCancelData.TYPE = data.reason.TYPE;
              jQuery('#modal-cancel-request').modal('show');
              changeReason();
            })
            .catch((err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.checkImage = (media) => {
          if (!this.selectedMedias.includes(media)) {
            this.selectedMedias.push(media);
          } else {
            const index = this.selectedMedias.indexOf(media);
            if (index && this.selectedMedias.length > index) {
              this.selectedMedias.splice(index);
            }
          }
        };
        this.confirmCancel = () => {
          if (this.viewRequest.TYPE === '01') {
            this.returnCancelData.DESCRIPTION = this.viewRequest.DESCRIPTION;
          } else if (!this.returnCancelData.DESCRIPTION || this.returnCancelData.DESCRIPTION.length < 1) {
            alert($translate.instant('취소사유를 입력해주세요.'));
            return;
          }
          this.returnCancelData.TB_ORDER_CANCEL_REQUEST_MEDIA_IDS = this.selectedMedias.map(media => media.ID);
          $resource(`${APIURL}/admin/orders/cancel/request/${this.viewRequest.ID}/confirm`).save(this.returnCancelData).$promise
            .then(() => {
              jQuery('#modal-cancel-request').modal('hide');
              this.paging(this.curPage);
            })
            .catch((err) => {
              errorHandler(err);
            });
        };
        this.rejectCancel = () => {
          $resource(`${APIURL}/admin/orders/cancel/request/${this.viewRequest.ID}/reject`).get().$promise
            .then(() => {
              jQuery('#modal-cancel-request').modal('hide');
              this.paging(this.curPage);
            })
            .catch((err) => {
              errorHandler(err);
            });
        };
        this.requests = {};
        this.totalCount = 0;
        this.curPage = 1;
        this.selectedStatus = '0';
        this.viewRequest = { CAR_BRAND: '' };
        this.returnCancelData = { TB_ORDER_CANCEL_REQUEST_MEDIA_IDS: [], DESCRIPTION: '' };
        this.paging(1);
        this.orderCancelReasonWithType = (request) => {
          const reason = getReasonFromType(request.TYPE);
          if (request.TYPE === '01') {
            return `${$translate.instant('기타')}(${request.DESCRIPTION})`;
          }
          return reason.MESSAGE;
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/wash-cancel-request/wash-cancel-request.component.js